<template>
  <div>
    <div v-if="no_search_result.length !== 0" class="mb-8">
      <h2 class="text-21 font-bold leading-1-19 text-onyx mb-4 md:mb-24px">
        {{ no_results_heading }}
      </h2>
      <p class="text-base text-onyx mb-8 leading-relaxed w-full lg:w-738px">
        {{ no_results_subheading }}
      </p>
    </div>
    <div
      class="mb-4 cursor-pointer"
      v-for="(job, index) in displayJobs"
      :key="index"
    >
    <a :href="getJobUrl(job)" @click="redirectToJobClick(job)">
      <div class="listing-card border-2 border-solid border-transparent">
        <div class="w-auto xl:w-1023px">
          <div class="flex p-6 rounded-8 w-auto lg:w-1023px">
            <div class="hidden md:flex w-16 h-16">
              <img
                class="flex object-contain w-full h-full rounded-md border border-solid border-chrome-lightest"
                :src="job['company']['logo']"
                :alt="job['company']['name'] + ' Logo'"
                :title="job['company']['name'] + ' Logo'"
              />
            </div>
            <div class="flex flex-col md:ml-8 flex-1">
              <div class="flex md:hidden w-16 h-16 mb-4">
                <img
                  class="flex object-contain w-full h-full rounded-md border border-solid border-chrome-lightest"
                  :src="job['company']['logo']"
                  :alt="job['company']['name'] + ' Logo'"
                  :title="job['company']['name'] + ' Logo'"
                />
              </div>

              <div class="w-full flex align-center justify-between md:mt-xs">
                <div
                  class="text-18 text-primary-darker font-medium leading-normal m-0 p-0 hover:underline cursor-pointer ellipse-two-lines line-height-normal"
                >
                  {{ getDisplayText(job) }}
                </div>

                <span v-if="job['is_featured']" class="hidden md:block h-26px">
                  <vs-chip color="rgba(124, 195, 102, 0.2)" class="self-start">
                    <span
                      class="m-0 p-0 text-12 text-onyx font-bold w-auto text-center"
                      >Hiring Now</span
                    >
                  </vs-chip>
                </span>
              </div>

              <div
                class="p-0 m-0 mt-4px text-14 text-onyx-lightest font-semibold"
              >
                {{ job['company']['name'] }}
              </div>

              <div
                class="text-onyx-lightest font-normal mt-14px lg:mt-8px w-full flex items-center"
              >
                <div class="h-22px w-22px flex justify-center items-center">
                  <vs-icon
                    class="text-lg"
                    icon="icon-map"
                    icon-pack="feather"
                  ></vs-icon>
                </div>

                <p class="ml-6px text-14 text-onyx-lightest">
                  {{ job['category'] }}
                </p>
              </div>

              <span v-if="job['is_featured']" class="md:hidden mt-16px h-26px">
                <vs-chip
                  color="rgba(124, 195, 102, 0.2)"
                  class="self-start mb-0"
                >
                  <span class="m-0 p-0 text-12 text-onyx font-bold w-auto"
                    >Hiring Now</span
                  >
                </vs-chip>
              </span>

              <div class="perks-wrapper w-auto mt-16px flex flex-wrap gap-2">
                <vs-chip
                  v-for="(perk, index) in job['job_perks']"
                  :key="index"
                  :color="perk['color_10']"
                  class="m-0 self-start rounded-6px w-auto md:w-72px"
                  style="min-width: fit-content !important"
                >
                  <span
                    class="m-0 p-0 text-12 text-onyx-lightest font-medium w-auto"
                  >
                    <object
                      v-if="perk['icon_url']"
                      :data="perk['icon_url']"
                      width="12"
                      height="12"
                      class="translate-icon-object"
                      :title="park['desc']"
                      :aria-label="park['desc']"
                    >
                      <span>{{ perk['desc'] }}</span>
                    </object>

                    {{ perk['desc'] }}
                  </span>
                </vs-chip>
                <vs-chip
                  v-if="job['is_hiring_event']"
                  class="m-0 self-start rounded-6px w-auto md:w-72px"
                  style="min-width: fit-content !important"
                >
                  <span
                    class="m-0 p-0 text-12 text-onyx-lightest font-medium w-auto"
                  >
                    Hiring Event
                  </span>
                </vs-chip>
              </div>
            </div>
            <hr
              v-if="showApplyButton"
              class="divider hidden md:block md:border-chrome-lightest md:border-solid -my-6 md:ml-8 md:mr-23px"
            />
            <div v-if="showApplyButton" class="hidden md:block my-auto">
              <a :href="getJobUrl(job)" @click.stop="redirectToJobClick(job)">
                <primary-button
                  size="large"
                  class="w-full lg:w-187px"
                  title="Apply"
                >
                  Apply
                </primary-button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </a>
    </div>

    <div
      class="w-full mx-auto mt-8 md:mt-10 lg:w-auto flex justify-center"
      @click="loadMoreJobs"
      v-if="showViewMoreBtn"
    >
      <primary-button
        size="large"
        class="bg-primary text-white text-14"
        title="Load 25 More Options"
      >
        Load {{ loadCount }} More Jobs
        <span class="ml-2" v-show="loadingMore"
          ><i class="fas fa-circle-notch fa-spin"></i
        ></span>
      </primary-button>
    </div>
  </div>
</template>

<script>
import { slugify } from '../../utilities/slugify';
import axios from 'axios';
import { SimpleSVG } from 'vue-simple-svg';
import event from '../../event';
import allEvents from '../../mixins/events';
import { getJobLink, redirectToJob } from "../jobUtil";

export default {
  name: 'JobsCdljnViewMore',
  mixins: [allEvents],
  props: {
    jobs: {
      type: Array,
      required: true,
    },
    showApplyButton: {
      type: Boolean,
      default: false,
    },
    thankyouUrl: {
      type: String,
      default: '',
    },
  },

  components: {
    SimpleSVG,
  },

  data: function () {
    return {
      jobsData: [],
      perPage: 25,
      totalJobs: 0,
      nextPageUrl: '',
      recommendedJobs: [],
      loadingMore: false,
      showViewMoreBtn: 0,
      jobsRemaining: 0,
      url: '',
      no_search_result: [],
      no_results_heading: '',
      no_results_subheading: '',
      all_jobs_id: [],
      total_jobs: 0,
    };
  },
  created() {
    let last_used_url = localStorage.getItem('job_api_url');
    let base_url = window.location.href;
    if (
      window.performance &&
      window.performance.navigation.type ===
        window.performance.navigation.TYPE_BACK_FORWARD
    ) {
      let redirect_url = last_used_url !== null ? last_used_url : base_url;
      let url = new URL(redirect_url);
      let urlSearchParams = new URLSearchParams(url.search);
      urlSearchParams.delete('is_ajax');
      url.search = urlSearchParams.toString();
      redirect_url = url.toString();
      window.location.href = redirect_url;
    } else {
      this.filteredJobs(base_url);
    }
    let vm = this;
    event.bus.$on('selected-filter-data', function (url) {
      vm.displayJobs = [];
      vm.showViewMoreBtn = 0;
      vm.filteredJobs(url);
    });
  },
  computed: {
    displayJobs: {
      get() {
        return this.jobsData;
      },
      set(newValue) {
        this.jobsData = newValue;
      },
    },
    totalPages() {
      return this.recommendedJobs.length;
    },
    loadCount() {
      return this.jobsRemaining > this.perPage
        ? this.perPage
        : this.jobsRemaining;
    },
  },

  methods: {
    filteredJobs(url) {
      this.url =
        url.indexOf('?') === -1 ? url + '?is_ajax=1' : url + '&is_ajax=1';
      localStorage.setItem('job_api_url', url);
      this.setJobTotal(
        '<i class="fa fa-spinner fa-spin fa-1x fa-fw"></i><span class="sr-only">Loading...</span>',
      );
      axios
        .get(this.url)
        .then(({ data }) => {
          this.displayJobs = data.jobs ? data.jobs : data.no_results_jobs;
          this.no_search_result = data.no_results_jobs;
          (this.no_results_heading = data.no_results_heading),
            (this.no_results_subheading = data.no_results_subheading),
            (this.nextPageUrl = data.jobs.next_page_url);
          this.jobsRemaining = data.total_jobs - data.jobs.length;
          this.showViewMoreBtn = this.jobsRemaining;
          this.all_jobs_id = data.all_jobs_id;
          this.total_jobs = data.total_jobs;
          this.setJobTotal(data.total_jobs);
        })
        .catch(err => console.log(err));
    },
    getDisplayText(job) {
      return process.env.MIX_MEILISEARCH_HOST &&
        process.env.MIX_APP_ENV === 'local'
        ? `${job.title} (${job.id}), Priority: ${job.priority}`
        : job.title;
    },
    loadMoreJobs() {
      this.loadingMore = true;
      let queryParams = this.url + '&all_jobs_id=' + this.all_jobs_id;

      this.setJobTotal(
        '<i class="fa fa-spinner fa-spin fa-1x fa-fw"></i><span class="sr-only">Loading...</span>',
      );
      axios
        .get(queryParams)
        .then(({ data }) => {
          this.displayJobs = [...this.displayJobs, ...data.jobs];
          this.all_jobs_id = [this.all_jobs_id, ...data.all_jobs_id];
          this.nextPageUrl = data.jobs.next_page_url;
          this.jobsRemaining = this.total_jobs - this.displayJobs.length;
          this.showViewMoreBtn = this.jobsRemaining;
          this.loadingMore = false;
          this.setJobTotal(this.total_jobs);
        })
        .catch(err => console.log(err));
    },

    getJobUrl(job) {
      return getJobLink(job);
    },

    redirectToJobClick(job) {
      redirectToJob(job, this.trackJobFullAppClick, this.thankyouUrl);
    },

    slugify(str) {
      return slugify(str);
    },

    setJobTotal(total) {
      const countDsktp = document.getElementById('total_jobs_count_desktop');
      if (total == null) {
        total = 0;
      }
      let totalHtmlText =
        total == 1 ? total + ' job found' : total + ' jobs found';

      if (countDsktp) {
        countDsktp.innerHTML = totalHtmlText;
      }

      const countMobile = document.getElementById('total_jobs_count_mobile');
      if (countMobile) {
        countMobile.innerHTML = totalHtmlText;
      }
    },
  },
};
</script>

<style scoped>
.ellipse-two-lines {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
